(function () {
  'use strict';

  function initLucky() {
    if (window.NRLucky) {
      window.NRLucky.bind('.nr-footer-panel .lucky-link');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLucky);
  } else {
    initLucky();
  }
})();
